<div class="sidenav-content">
	<div class="card-title-block-non-sticky">
		<copo-back-button></copo-back-button>
		<span class="card-title-label" translate>menu.product-services</span>
	</div>
	<div class="service-grid-container copo-container">
		<copo-auction-offer-widget *ngIf="user.hasService('PAUCT')" headerLabel="auction.entry"
			btnLabel="auction.new.offer.check" btnRouterLink="/auction/bidding/offer-selection">
		</copo-auction-offer-widget>
		<copo-request-claim-widget *ngIf="hasRaiseIssueService()" headerLabel="claim.dashboard.services.claims"
			btnLabel="claim.raise-new-quality-issue" btnRouterLink="/quality-issues/new/batch-selection">
		</copo-request-claim-widget>
		<copo-request-guarantee-widget *ngIf="hasGuaranteeService()" headerLabel="quality.guarantee.request"
			btnLabel="claim.guarantee.request" btnRouterLink="/guarantee-requests/new/guarantee-type-selector">
		</copo-request-guarantee-widget>
		<copo-eaqdb-widget *ngIf="user.hasService('PAQDB')" headerLabel="aqdb.label"
			btnLabel="aqdb.quality.data" btnRouterLink="/aqdb/datacenter">
		</copo-eaqdb-widget>
	</div>
</div>